module.exports = __webpack_public_path__ + "img/work_with_us.08096be1.jpg";